import {
    StreamRequestInfo,
    WidgetRestByRequestUidConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import State from 'store/State';
import { DataServices } from 'store/Services';
import { WidgetId } from 'widgets/WidgetId';
import { selectPortfolioSelection } from 'portfolio/store/selectors';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';
import { selectWidgetInstanceConfig } from 'widgets/store/selectors';

import { toRequest } from 'widgets/estimatedTradeCost/store/data/mapping';
import {
    EstimatedTradeCostRequest,
    toUid,
} from 'widgets/estimatedTradeCost/store/data/EstimatedTradeCostRequest';
import { EstimatedTradeCostApiResponse } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiResponse';
import { selectWidgetComponentState } from 'widgets/store/component/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { estimatedTradeCostStreamConfig } from 'widgets/estimatedTradeCost/widget/stream-config';
import { EstimatedTradeCostComparisonConfigState } from 'widgets/estimatedTradeCost/widget-comparison/store/EstimatedTradeCostComparisonConfigState';
import { EstimatedTradeCostComparisonComponentState } from 'widgets/estimatedTradeCost/widget-comparison/store/componentSlice';

export const estimatedTradeCostComparisonStreamConfig: WidgetRestByRequestUidConfig<
    EstimatedTradeCostRequest,
    EstimatedTradeCostApiResponse
> = {
    ...estimatedTradeCostStreamConfig,
    getWidgetStreamRequestInfo(
        state: State,
        services: DataServices,
        id: WidgetId
    ): Promise<
        | StreamRequestInfo<EstimatedTradeCostRequest>[]
        | StreamRequestInfo<EstimatedTradeCostRequest>
        | undefined
    > {
        return Promise.resolve(
            getEstimatedTradeCostStreamComparisonRequestInfos(
                state,
                services,
                id
            )
        );
    },
};

function getEstimatedTradeCostStreamComparisonRequestInfos(
    state: State,
    services: DataServices,
    widgetId: WidgetId
): StreamRequestInfo<EstimatedTradeCostRequest>[] {
    const selection = selectPortfolioSelection(state);
    const selectionWrapper = new PortfolioSelectionWrapper(selection);

    const order = selectionWrapper.selectedOrder;
    const config = selectWidgetInstanceConfig(
        state,
        widgetId
    ) as EstimatedTradeCostComparisonConfigState;
    const componentState =
        selectWidgetComponentState<EstimatedTradeCostComparisonComponentState>(
            state,
            WidgetType.EST_TRADE_COST_COMPARISON_WIDGET,
            widgetId.widgetKey
        );

    const infos: Array<
        StreamRequestInfo<EstimatedTradeCostRequest> | undefined
    > = config.optimizations.map((optimizationConfig) => {
        const request = toRequest(order, optimizationConfig, componentState);

        if (!request || (!request.orderQtyRemaining && !request.specifiedQty)) {
            return undefined;
        }

        const uid = toUid(request);

        return {
            streamKey: uid,
            payloadUid: uid,
            payload: request,
        };
    });

    return infos.filter(
        (i) => !!i
    ) as StreamRequestInfo<EstimatedTradeCostRequest>[];
}
